import { ChangeDetectionStrategy, Component, forwardRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DashboardTileType } from '@store';
import { ViCardComponent } from '../../../../../projects/ui/components/card/card.component';
import { ViLoaderComponent } from '../../../../../projects/ui/components/loader/loader.component';
import { CommonStandaloneModule } from '../../../../shared/common-standalone.module';
import { DashboardTileNamePipe } from '../../../pipes/dashboard-tile-name/dashboard-tile-name.pipe';
import { DashboardTileInstallationListComponent } from '../dashboard-tile-installation-list/dashboard-tile-installation-list.component';
import { TileModalFooterActionsComponent } from './tile-modal-footer-actions/tile-modal-footer-actions.component';

@Component({
  selector: 'app-dashboard-tile-modal',
  templateUrl: './dashboard-tile-modal.component.html',
  styleUrls: ['./dashboard-tile-modal.component.scss'],
  standalone: true,
  imports: [
    forwardRef(() => CommonStandaloneModule),
    ViCardComponent,
    MatIconModule,
    DashboardTileInstallationListComponent,
    ViLoaderComponent,
    DashboardTileNamePipe,
    TileModalFooterActionsComponent,
  ],
  providers: [DashboardTileNamePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardTileModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      tileType: DashboardTileType;
    },
    private dialogRef: MatDialogRef<DashboardTileModalComponent>
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
